import { Component, OnInit } from '@angular/core';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-breadcrumb-item',
	styleUrls: ['./breadcrumb-item.component.css'],
	templateUrl: './breadcrumb-item.component.html'
})
export class BreadcrumbItemComponent implements OnInit {
	public showLoader = false;
	public showError = false;

	constructor() {
		EmitterService.get(EVENT_EMITTERS.CAMPAIGN_LOADED).subscribe((response: any) => {
			if (response) {
				setTimeout(() => {
					this.showLoader = !response;
				}, 500);
			} else {
				this.showLoader = !response;
			}
		});
		EmitterService.get(EVENT_EMITTERS.VALIDATION).subscribe((response: any) => {
			this.showError = !response;
		});
	}

	ngOnInit(): void {}

	clicked(): void {
		if (!this.showLoader && !this.showError) {
			setTimeout(() => {
				EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).emit(true);
			}, 600);
		}
	}
}
